import React, {Component, Fragment} from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import Xhr from "../../../helpers/Xhr";

class League extends Component {
	state = {
		maximum : 0,
		reserve : 0
	};

	componentWillMount() {
		const {league} = this.props;
		if ( league.hasOwnProperty('maximum') && league.hasOwnProperty('reserve') ) {
			this.setState({
				maximum : league.maximum,
				reserve : league.reserve
			});
		}
	}

	inputChange(e) {
		const stateChange = {
			[e.target.name] : e.target.value
		};

		this.setState({...this.state, ...stateChange})
	}

	changeData() {
		const {league} = this.props;
		const data = {
			leagueId : +league.id,
			maximum  : this.state.maximum,
			reserve  : this.state.reserve
		};

		Xhr.changeLeague(data).then((resp) => {
			if ( resp.status === 'error' ) {
				alert(resp.messages);
			}
		});
	}

	render() {
		const {league, checkHandler, isChecked, user} = this.props;

		let isNeedMax = false;
		if ( user.info.hasOwnProperty('role') && (user.info.role === 'root' || user.info.role === 'bookmaker') ) {
			isNeedMax = true;
		}

		if ( user.info.hasOwnProperty('role') && user.info.role === 'cyber' && +league.sport_id === 43 ) {
			isNeedMax = true;
		}

		return (
			<Fragment>
				<div className="tr">
					<div className="td favorite">
						<div className="checkbox">
							<input type="checkbox"
							       id={`line-league-${league.id}`}
							       value={league.id}
							       onChange={checkHandler}
							       checked={isChecked}/>
							<label htmlFor={`line-league-${league.id}`}/>
						</div>
					</div>
					<div className="td players">
						<Link to={`/line-leagues/${league.id}`}>{league.name}</Link>
					</div>
				</div>

				{isNeedMax &&
				<div className="tr editor">
					<div className="td favorite"></div>
					<div className="td players">
						<input type="text" name="maximum" onChange={this.inputChange.bind(this)}
						       value={this.state.maximum}/>

						<input type="text" name="reserve" onChange={this.inputChange.bind(this)}
						       value={this.state.reserve}/>

						<input type="button"
						       className="buttons__show"
						       name="save"
						       value="Сохранить"
						       onClick={this.changeData.bind(this)}/>
					</div>
				</div>}
			</Fragment>

		);
	}
}

export default connect(
	state => ({
		user : state.user
	}),
	dispatch => ({})
)(League);


// WEBPACK FOOTER //
// ./src/app/pages/LineSelect/modules/League.js